<template>
  <div class="a4">
    <div style="margin-bottom: 16px;">
      <h3 style="background-color: #3A3C84; padding: 10px 16px; margin-bottom: 26px">① 총괄 현황</h3>
      <div class="grid" style="gap: 4px; font-weight: 400; font-size: 26px; line-height: 170%; letter-spacing: 0; vertical-align: middle;">
        <div class="flex items-center">
          <div class="bullseye" style="margin-right: 10px; text-align-last: justify;">부 서 명</div>
          <div>{{ value.소관부서 }}</div>
        </div>

        <div class="flex items-center">
          <div class="bullseye" style="margin-right: 10px; text-align-last: justify;">점검기간</div>
          <div>{{ value.점검기간.sDate }} ~ {{ value.점검기간.eDate }}</div>
        </div>

        <div class="flex items-center">
          <div class="bullseye" style="margin-right: 10px; text-align-last: justify;">점검내용</div>
          <div>{{ value.점검내용 }}</div>
        </div>

        <div class="flex items-center">
          <div class="bullseye" style="margin-right: 10px; text-align-last: justify;">총&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;평</div>
          <div>{{ value.총평 }}</div>
        </div>

        <div>
          <div class="bullseye none-colon">시설개요</div>
          <div v-for="(field, index) in value.fields" style="margin-top: 14px;">
            <table class="double-border-header" style="border-width: 2px 0 2px 0; border-style: solid; border-color: #757575;">
              <colgroup>
                <col width="180px"/>
                <col/>
              </colgroup>
              <thead>
                <tr style="border-bottom: 6px double #757575;">
                  <th class="num-title">
                    <div>
                      <span>①</span><span style="text-align-last: justify;">시 설 명</span>
                    </div>
                  </th>
                  <td style="border-left: 1px solid #757575; text-align: center">{{ field.field_name }}</td>
                </tr>
              </thead>
              <tbody>
              <tr style="border-bottom: 1px solid #757575;">
                <th class="num-title">
                  <div>
                    <span>②</span><span style="text-align-last: justify;">주 소</span>
                  </div>
                </th>
                <td style="border-left: 1px solid #757575; text-align: center">{{ field.address }}</td>
              </tr>
              <tr style="border-bottom: 1px solid #757575;">
                <th class="num-title">
                  <div>
                    <span>③</span><span style="text-align-last: justify;">규 모</span>
                  </div>
                </th>
                <td style="border-left: 1px solid #757575; text-align: center">{{ field.규모 }}</td>
              </tr>
              <tr style="border-bottom: 1px solid #757575;">
                <th class="num-title">
                  <div>
                    <span>③</span><span style="text-align-last: justify;">대상법령</span>
                  </div>
                </th>
                <td style="border-left: 1px solid #757575; text-align: center">{{ field.대상법령 }}</td>
              </tr>
              <tr style="border-bottom: 1px solid #757575;">
                <th class="num-title align-middle">
                  <div>
                    <span>④</span><span style="text-align-last: justify;">시설종류</span>
                  </div>
                </th>
                <td style="font-size:18px; border-left: 1px solid #757575;">
                  <div style="padding: 5px 10px;">{{ field.시설종류 }}</div>
                </td>
              </tr>
              <tr style="border-bottom: 1px solid #757575;">
                <th class="num-title">
                  <div>
                    <span>⑤</span><span style="text-align-last: justify;">관리형태</span>
                  </div>
                </th>
                <td style="border-left: 1px solid #757575; text-align: center">{{ field.관리형태 }}</td>
              </tr>
              <tr style="border-bottom: 1px solid #757575;">
                <th class="num-title">
                  <div>
                    <span>⑥</span><span style="text-align-last: justify;">위탁시설</span>
                  </div>
                </th>
                <td style="border-left: 1px solid #757575; text-align: center">
                  <div class="flex p-0">
                    <span style="width: 182px; padding: 5px 10px; font-weight: 700;">위탁부서</span>
                    <span style="width:182px; padding: 5px 10px; border-left: 1px solid #757575;">{{ field.위탁부서 }}</span>

                    <span style="width: 182px; padding: 5px 10px; font-weight: 700; border-left: 1px solid #757575;">위탁기간</span>
                    <span style="padding: 5px 10px; border-left: 1px solid #757575;">{{ field.위탁기간.sDate }} ~ {{ field.위탁기간.eDate }}</span>
                  </div>
                </td>
              </tr>
              <tr style="border-bottom: 1px solid #757575;">
                <th class="num-title">
                  <div>
                    <span>⑦</span><span style="text-align-last: justify;">수탁현황</span>
                  </div>
                </th>
                <td style="border-left: 1px solid #757575; text-align: center">
                  <div class="flex p-0">
                    <span class="flex items-center justify-center" style="width: 200px; padding: 5px 10px; font-weight: 700;">기관명</span>
                    <span class="flex items-center justify-center" style="width:223px; padding: 5px 10px; border-left: 1px solid #757575;">{{ field.수탁기관명 }}</span>

                    <span class="flex items-center justify-center" style="width: 200px; padding: 5px 10px; font-weight: 700; border-left: 1px solid #757575;">수탁비용</span>
                    <span class="flex items-center justify-center" style="width: 223px; padding: 5px 10px; border-left: 1px solid #757575;">{{ field.수탁비용 }}</span>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
            <div class="text-hint" style="font-size: 22px;">※ ⑥, ⑦번 항목은 위탁시설만 기재</div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <h3 style="background-color: #2B2D63; padding: 10px 16px; margin-bottom: 26px">② 안전관리 추진현황</h3>
      <div class="grid" style="margin-bottom: 14px;">
        <div class="bullseye none-colon" style="width: 228px">안전예산 집행내역</div>
        <div style="font-size: 20px; margin-left: auto;">[단위: 천원]</div>
      </div>
      <div>
        <table class="double-border-header" style="border-width: 2px 0 2px 0; border-style: solid; border-color: #757575;">
          <thead>
          <tr class="border-center" style="border-bottom: 6px double #757575;">
            <th style="border-right: 1px solid #757575;"><div style="padding: 5px 10px; text-align: center;">구분</div></th>
            <th style="border-right: 1px solid #757575;"><div style="padding: 5px 10px; text-align: center;">편성액</div></th>
            <th style="border-right: 1px solid #757575;"><div style="padding: 5px 10px; text-align: center;">집행액</div></th>
            <th style="border-right: 1px solid #757575;"><div style="padding: 5px 10px; text-align: center;">잔액</div></th>
            <th><div style="padding: 5px 10px; text-align: center;">추가소요액</div></th>
          </tr>
          </thead>
          <tbody>
          <tr class="border-center" style="border-bottom: 1px solid #757575; text-align: center;">
            <td><div style="padding: 5px 10px; border-right: 1px solid #757575;">합계</div></td>
            <td><div style="padding: 5px 10px; border-right: 1px solid #757575;">{{ value.합계.편성액 | comma }}</div></td>
            <td><div style="padding: 5px 10px; border-right: 1px solid #757575;">{{ value.합계.집행액 | comma }}</div></td>
            <td><div style="padding: 5px 10px; border-right: 1px solid #757575;">{{ value.합계.잔액 | comma }}</div></td>
            <td><div style="padding: 5px 10px;">{{ value.합계.추가소요액 | comma }}</div></td>
          </tr>
          <tr class="border-center" style="border-bottom: 1px solid #757575; text-align: center;">
            <td><div style="padding: 5px 10px; border-right: 1px solid #757575;">안전점검</div></td>
            <td><div style="padding: 5px 10px; border-right: 1px solid #757575;">{{ value.집행내역.안전점검.편성액 | comma }}</div></td>
            <td><div style="padding: 5px 10px; border-right: 1px solid #757575;">{{ value.집행내역.안전점검.집행액 | comma }}</div></td>
            <td><div style="padding: 5px 10px; border-right: 1px solid #757575;">{{ value.집행내역.안전점검.잔액 | comma }}</div></td>
            <td><div style="padding: 5px 10px;">{{ value.집행내역.안전점검.추가소요액 | comma }}</div></td>
          </tr>
          <tr class="border-center" style="border-bottom: 1px solid #757575; text-align: center;">
            <td><div style="padding: 5px 10px; border-right: 1px solid #757575;">보수보강</div></td>
            <td><div style="padding: 5px 10px; border-right: 1px solid #757575;">{{ value.집행내역.보수보강.편성액 | comma }}</div></td>
            <td><div style="padding: 5px 10px; border-right: 1px solid #757575;">{{ value.집행내역.보수보강.집행액 | comma }}</div></td>
            <td><div style="padding: 5px 10px; border-right: 1px solid #757575;">{{ value.집행내역.보수보강.잔액 | comma }}</div></td>
            <td><div style="padding: 5px 10px;">{{ value.집행내역.보수보강.추가소요액 | comma }}</div></td>
          </tr>
          <tr class="border-center" style="border-bottom: 1px solid #757575; text-align: center;">
            <td><div style="padding: 5px 10px; border-right: 1px solid #757575;">안전조치</div></td>
            <td><div style="padding: 5px 10px; border-right: 1px solid #757575;">{{ value.집행내역.안전조치.편성액 | comma }}</div></td>
            <td><div style="padding: 5px 10px; border-right: 1px solid #757575;">{{ value.집행내역.안전조치.집행액 | comma }}</div></td>
            <td><div style="padding: 5px 10px; border-right: 1px solid #757575;">{{ value.집행내역.안전조치.잔액 | comma }}</div></td>
            <td><div style="padding: 5px 10px;">{{ value.집행내역.안전조치.추가소요액 | comma }}</div></td>
          </tr>
          <tr class="border-center" style="border-bottom: 1px solid #757575; text-align: center;">
            <td><div style="padding: 5px 10px; border-right: 1px solid #757575;">인건비*</div></td>
            <td><div style="padding: 5px 10px; border-right: 1px solid #757575;">{{ value.집행내역.인건비.편성액 | comma }}</div></td>
            <td><div style="padding: 5px 10px; border-right: 1px solid #757575;">{{ value.집행내역.인건비.집행액 | comma }}</div></td>
            <td><div style="padding: 5px 10px; border-right: 1px solid #757575;">{{ value.집행내역.인건비.잔액 | comma }}</div></td>
            <td><div style="padding: 5px 10px;">{{ value.집행내역.인건비.추가소요액 | comma }}</div></td>
          </tr>
          <tr class="border-center" style="border-bottom: 1px solid #757575; text-align: center;">
            <td><div style="padding: 5px 10px; border-right: 1px solid #757575;">기타</div></td>
            <td><div style="padding: 5px 10px; border-right: 1px solid #757575;">{{ value.집행내역.기타.편성액 | comma }}</div></td>
            <td><div style="padding: 5px 10px; border-right: 1px solid #757575;">{{ value.집행내역.기타.집행액 | comma }}</div></td>
            <td><div style="padding: 5px 10px; border-right: 1px solid #757575;">{{ value.집행내역.기타.잔액 | comma }}</div></td>
            <td><div style="padding: 5px 10px;">{{ value.집행내역.기타.추가소요액 | comma }}</div></td>
          </tr>
          </tbody>
        </table>
        <div class="text-hint" style="margin-top: 14px; font-size: 18px; display: grid; grid-template-columns: auto 1fr;">
          <span>*</span>
          <div>
            직접관리 시설은 안전관리를 위해 채용한 기간제, 일시사역 인력(공무원·공무직인건비 제외)의 인건비만 기재<br>
            위탁관리 시설은 안전관리 전체 인원의 인건비 기재
          </div>
        </div>
        <div style="margin-top: 14px; display: flex; align-items: center;">
          <span style="font-size: 26px">- 추가 소요액 확보계획 :</span>
          <span style="margin-left:10px; font-size: 21px">{{ value.추가소요액확보계획 }}</span>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  props: {
    header: Object,
    board: Object,
    value: Object,
  },
  computed: {
  },
  methods: {
  }
}
</script>
